// TODO: COO-215 complete types and unit test
/* istanbul ignore file */
import { mock } from 'universal-mock';

// @ts-ignore
import * as serviceWorkerPath from './sw';

/**
 * @description We are using service work for Clevertap Web Push
 *              When testing locally, you need HTTPS.
 *              See https://mokapos.atlassian.net/wiki/spaces/MT/pages/23429121/Developing+with+HTTPS
 */
async function setupClevertap() {
  const viteClevertapId = import.meta.env.VITE_CLEVERTAP_ID;

  if (!viteClevertapId) {
    return;
  }

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register(serviceWorkerPath);
  }

  if (window?.initClevertap) {
    // Run the init script from GTM
    window.initClevertap(viteClevertapId);
  } else {
    // Init script / GTM isn't ready yet, provide the getClevertapId so that
    // the GTM can run it later
    // eslint-disable-next-line func-names
    window.getClevertapId = function () {
      return viteClevertapId;
    };
  }
}

function setupTrackers() {
  window.clevertap = window.clevertap ?? mock;
  setupClevertap();
}

export default setupTrackers;
